module.exports = __webpack_public_path__ + "media/images/lb/221-1e09fb8eaf996054380cd3730c44e836.svg";